import React, { Component } from "react";

class PayrollHeaderDisplay extends Component {
  constructor(props) {
    super(props);
    this.objectURLs = [];
  }

  componentWillUnmount() {
    this.objectURLs.forEach((url) => URL.revokeObjectURL(url));
  }

  getImageSrc = (file) => {
    if (!file) {
      return "";
    }
    
    if (typeof file === "string") {
      return file;
    }
    
    if (!(file instanceof Blob) && !(file instanceof File)) {
      console.warn("Invalid file type in getImageSrc:", file);
      return "";
    }
    
    try {
      const url = URL.createObjectURL(file);
      this.objectURLs.push(url);
      return url;
    } catch (error) {
      console.error("Failed to create object URL:", error);
      return "";
    }
  };

  render() {
    const { header } = this.props;

    // Default values
    const leftLogo = header?.leftLogo || [];
    const rightLogo = header?.rightLogo || [];
    const topTitle = header?.topTitle || "Republic Of the Philippines";
    const mainTitle = header?.mainTitle || "BUREAU OF IMMIGRATION";
    const motto = header?.motto || "Patriotism * Integrity * Professionalism";
    const topTitleStyle = header?.topTitleStyle || { 
      color: "#000000", 
      fontSize: 16, 
      bold: false, 
      italic: false 
    };
    const mainTitleStyle = header?.mainTitleStyle || { 
      color: "#000000", 
      fontSize: 32, 
      bold: true, 
      italic: false 
    };
    const mottoStyle = header?.mottoStyle || { 
      color: "#000000", 
      fontSize: 14, 
      bold: false, 
      italic: false 
    };
    const leftLogoPosition = header?.leftLogoPosition !== undefined ? header.leftLogoPosition : 110;
    const rightLogoPosition = header?.rightLogoPosition !== undefined ? header.rightLogoPosition : 120;
    const leftLogoSize = header?.leftLogoSize !== undefined ? header.leftLogoSize : 120;
    const rightLogoSize = header?.rightLogoSize !== undefined ? header.rightLogoSize : 120;
    const topTitleMarginBottom = header?.topTitleMarginBottom !== undefined ? header.topTitleMarginBottom : 0;
    const mottoMarginTop = header?.mottoMarginTop !== undefined ? header.mottoMarginTop : 0;

    const centerPaddingLeft = leftLogoPosition + leftLogoSize;
    const centerPaddingRight = rightLogoPosition + rightLogoSize;

    return (
      <div className="header-preview bg-white p-4" style={{ position: "relative", width: "100%", minHeight: `${Math.max(leftLogoSize, rightLogoSize, 120) + 40}px`, maxWidth: "1000px", margin: "0 auto", display: "flex", alignItems: "center" }}>
        {/* Left Logo */}
        <div
          className="logo-container"
          style={{
            position: "absolute",
            left: `${leftLogoPosition}px`,
            top: "50%",
            transform: "translateY(-50%)",
            width: `${leftLogoSize}px`,
            height: `${leftLogoSize}px`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {leftLogo && leftLogo.length > 0 ? (
            <img
              src={this.getImageSrc(leftLogo[0])}
              alt="Left Logo"
              style={{
                maxWidth: "100%",
                maxHeight: "100%",
                objectFit: "contain",
              }}
            />
          ) : (
            <div
              className="text-muted text-center"
              style={{ fontSize: "12px" }}
            >
              No Logo
            </div>
          )}
        </div>

        {/* Center Content */}
        <div className="text-center" style={{ flex: 1, padding: "10px 20px", paddingLeft: `${centerPaddingLeft}px`, paddingRight: `${centerPaddingRight}px`, width: "100%", minWidth: 0 }}>
            <div
              style={{
                fontSize: `${topTitleStyle.fontSize}px`,
                fontWeight: topTitleStyle.bold ? "bold" : "400",
                fontStyle: topTitleStyle.italic ? "italic" : "normal",
                color: topTitleStyle.color,
                marginBottom: `${topTitleMarginBottom}px`,
              }}
            >
              {topTitle}
            </div>
            <div
              className="text-center"
              style={{
                padding: "8px 0",
                margin: "8px 0",
              }}
            >
              <div
                style={{
                  display: "inline-block",
                }}
              >
                <div
                  style={{
                    width: "100%",
                    height: "2px",
                    backgroundColor: "#000000",
                    marginBottom: "5px",
                    marginTop: "0px"
                  }}
                ></div>
                <h2
                  className="mb-0"
                  style={{
                    fontSize: `${mainTitleStyle.fontSize}px`,
                    fontWeight: mainTitleStyle.bold ? "bold" : "normal",
                    fontStyle: mainTitleStyle.italic ? "italic" : "normal",
                    color: mainTitleStyle.color,
                    letterSpacing: "2px",
                  }}
                >
                  {mainTitle}
                </h2>
              </div>
            </div>
            <div
              style={{
                fontSize: `${mottoStyle.fontSize}px`,
                fontWeight: mottoStyle.bold ? "bold" : "400",
                fontStyle: mottoStyle.italic ? "italic" : "normal",
                color: mottoStyle.color,
                marginTop: `${mottoMarginTop}px`,
              }}
            >
              {motto}
            </div>
          </div>

        {/* Right Logo */}
        <div
          className="logo-container"
          style={{
            position: "absolute",
            right: `${rightLogoPosition}px`,
            top: "50%",
            transform: "translateY(-50%)",
            width: `${rightLogoSize}px`,
            height: `${rightLogoSize}px`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {rightLogo && rightLogo.length > 0 ? (
            <img
              src={this.getImageSrc(rightLogo[0])}
              alt="Right Logo"
              style={{
                maxWidth: "100%",
                maxHeight: "100%",
                objectFit: "contain",
              }}
            />
          ) : (
            <div
              className="text-muted text-center"
              style={{ fontSize: "12px" }}
            >
              No Logo
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default PayrollHeaderDisplay;

